var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class TemplateBooks extends Component {
    constructor() {
        super('TemplateBooks', false);
        this.rotations = [];
        this.sliceWidth = 0;
        this.bookSize = 0;
        this.isToggling = false;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            let direction = 1;
            $('.book').on('click', (event, book) => {
                if (event.target.tagName == 'A' || $(event.target).parent().get(0).tagName == 'A')
                    return;
                event.preventDefault();
                if (this.isToggling)
                    return;
                this.isToggling = true;
                $('.book').each((otherBook) => {
                    if (otherBook.index() != book.index() && otherBook.hasClass('is-opened'))
                        this.toggleBook(otherBook);
                });
                this.toggleBook(book);
                setTimeout(() => {
                    this.isToggling = false;
                }, 500);
            });
            //update book size on resize
            $(window).on('resize', () => {
                this.updateSizes();
            });
            // Shuffle .book elements in .book-shelf
            this.shuffleBooks();
            // End of stuff
            this.updateSizes();
            this.success();
        });
    }
    toggleBook(book) {
        const direction = book.hasClass('is-opened') ? -1 : 1;
        if ($(window).width() < 992 || $(window).height() < 700) {
            book.toggleClass('is-opened');
            return;
        }
        if (this.rotations[book.index()] === undefined)
            this.rotations[book.index()] = 0;
        book.removeClass('is-opened');
        const intervalID = setInterval(() => {
            this.rotations[book.index()] += 6 * direction;
            if (this.rotations[book.index()] <= 0 || this.rotations[book.index()] >= 90) {
                if (this.rotations[book.index()] >= 90)
                    book.addClass('is-opened');
                clearInterval(intervalID);
            }
            book.css('--rotation', this.rotations[book.index()] + 'deg');
            book.find('.book-slice, .book-cover').each((element) => {
                this.updateApparentWidth(element, this.rotations[book.index()]);
            });
        }, 20);
    }
    updateSizes() {
        this.sliceWidth = parseInt($('.book').css('--slice-width'));
        this.bookSize = parseInt($('.book').css('--book-size'));
        $('.book').css('--calculated-book-size', $('.book').width() + 'px');
    }
    updateApparentWidth(element, rotation) {
        const width = (element.hasClass('book-cover') ? this.bookSize : this.sliceWidth);
        const finalRotation = (element.hasClass('book-cover') ? rotation : 90 - rotation);
        //const apparentWidth = width * Math.cos(finalRotation * Math.PI / 180);
        const apparentWidth = finalRotation * width / 90;
        element.parent().width(apparentWidth + 'px');
    }
    shuffleBooks() {
        const bookShelf = $('.book-shelf');
        const bookArray = [];
        if (bookShelf.length === 0)
            return;
        bookShelf.find('.book').each((book) => {
            bookArray.push(book);
        });
        bookArray.sort(() => Math.random() - 0.5);
        bookShelf.empty();
        bookArray.forEach((book) => {
            bookShelf.append(book);
        });
        bookShelf.addClass('is-shuffled');
    }
}
